import {
    apiRequest,
    acmanajerialLevel,
    acmanajerialDetail
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", acmanajerialDetail, {
            params: query
        }, true)
    }

    fetchLevel = async (query) => {
        return await apiRequest("get", acmanajerialLevel, {
            params: query
        }, true)
    }
}

export default DetailRepository